/// <reference types="./time.d.mts" />
import * as $attribute from "../../../../lustre/lustre/attribute.mjs";
import * as $css from "../../../../sketch/sketch/css.mjs";
import * as $html from "../../../../sketch_lustre/sketch/lustre/element/html.mjs";
import { toList } from "../../../gleam.mjs";

export function time_container(children) {
  let _pipe = $css.class$(toList([]));
  return $html.div(_pipe, toList([]), children);
}

export function date_display(id, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.justify_content("center"),
      $css.align_items("center"),
    ]),
  );
  return $html.div(_pipe, toList([$attribute.id(id)]), children);
}
